import React from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useQuery } from '@apollo/react-hooks';
import { GET_RENTAL_ITEMS_TITLES } from 'graphql/queries/rental-items';

export const useRentalItemValidation = (editingItemId = null) => {
  const businessOwner = useSelector(state => state.businessOwner)
  const ownerId = businessOwner.selectedBusinessOwner.ownerId || 
                  businessOwner.selectedBusinessOwner.id;  

  const { data: existingItemsTitlesData, loading } = useQuery(GET_RENTAL_ITEMS_TITLES, {
    variables: {
    businessOwnerId: ownerId 
    },
    fetchPolicy: 'network-only',
    skip: !ownerId 
    });

  const { enqueueSnackbar } = useSnackbar();
  const [validationErrors, setValidationErrors] = React.useState({
    title: null,
    title_no: null,
  });

  const [formData, setFormData] = React.useState({
    title: '',
    title_no: ''
  });

  const existingItems = React.useMemo(() => {
    if (!existingItemsTitlesData?.rentalItemsTitles) return [];
    return existingItemsTitlesData.rentalItemsTitles.filter(
      item => item.id !== editingItemId
    );
  }, [existingItemsTitlesData, editingItemId]);

  const validateTitle = (title, titleNo) => {
    const errors = { title: null, title_no: null };

    const titleExists = existingItems.some(
      item => item.title?.trim().toLowerCase() === title.trim().toLowerCase()
    );
    if (titleExists) {
      errors.title = 'A rental item with this title already exists.';
      enqueueSnackbar('A rental item with this title already exists.', { variant: 'error' });
   
      
    }

    if (titleNo) {
      const titleNoExists = existingItems.some(
        item => item.titleNo?.trim().toLowerCase() === titleNo.trim().toLowerCase()
      );
      if (titleNoExists) {
        errors.title_no = 'A rental item with this Norwegian title already exists.';
        enqueueSnackbar('A rental item with this Norwegian title already exists.', { variant: 'error' });
      }
    }

    return errors;
  };

  const validateOnSubmit = (formValues) => {
    const title = formValues.title || formData.title;
    const titleNo = formValues.title_no || formData.title_no;
    const errors = validateTitle(title, titleNo);
    setValidationErrors(errors);
    return !errors.title && !errors.title_no;
  };

  const updateField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));

    const updatedTitle = field === 'title' ? value : formData.title;
    const updatedTitleNo = field === 'title_no' ? value : formData.title_no;
    const errors = validateTitle(updatedTitle, updatedTitleNo);
    setValidationErrors(errors);
  };


  return {
    validationErrors,
    formData,
    validateOnSubmit,
    updateField,
    loading
  };
};

